export {default as CorrectCheckmark} from './correct-checkmark';
export {default as WrongX} from './wrong-x';